import { CommonTableUI } from "./TableTemplate/common";
import { Report } from "../Interfaces/TableInterfaces";
import { PortfoInfo } from "../Interfaces/stepInterfaces";

interface IPortfoTableProps {
  tableData: Report<PortfoInfo>;
  username: string;
}

const PortfoTable = ({ tableData, username }: IPortfoTableProps) => {
  // const getReports = (report?: PortfoInfo[]): PortfoInfo[] => {
  //   const res: PortfoInfo[] = [];

  //   if (report?.length)
  //     report.map((r, index) => {
  //       res.push({ ...r, row: index });
  //     });

  //   if (res.length < 5)
  //     for (let i = 0; i < 5 - length; i++)
  //       res.push({
  //         id: i,
  //         row: i,
  //         amount: 0,
  //         insName: "",
  //         price: "",
  //       });

  //   return res;
  // };

  // const getTableReports = (): Report<PortfoInfo> => {
  //   const res: Report<PortfoInfo> = {
  //     report: getReports(tableData),
  //     translatedHeaders: [
  //       { headerName: "insName", translateHeaderName: "نام نماد" },
  //       {
  //         headerName: "amount",
  //         translateHeaderName: "مقدار",
  //         typeStr: "Price",
  //       },
  //       {
  //         headerName: "price",
  //         translateHeaderName: "قیمت",
  //         typeStr: "Price",
  //       },
  //     ],
  //   };
  //   return res;
  // };

  return (
    <div className="flex flex-col justify-start items-start gap-2">
      <div>{username}</div>
      <CommonTableUI reports={tableData} />
    </div>
  );
};

export default PortfoTable;
